import React from "react";
import ComplianceStatusComponent from "./ComplianceStatusComponent";
import ActionIconsTableItem from "./ActionIconsTableItem";
import SelectableTable from "../../../common/components/SelectableTable/SelectableTable";
import ReviewModalButton from "./ReviewModalButton";
import SimpleTableItem from "../../../common/components/SimpleTableItem";
import TablePagination from "../../../common/components/TablePagination";

const BASE_TABLE_HEADERS = ["Student name", "DOB", "Student ID", "School", "Grade", "Required immunizations", ""];
const BASE_ITEM_KEYS = ["full_name", "date_of_birth_with_age", "student_id", "school", "grade", "required_immunizations_status", "actions"];

const StudentProfilesTable = ({
  metaProps,
  pendingReview,
  studentProfiles,
  testGroup,
}) => {
  const tableHeaders = pendingReview ? [...BASE_TABLE_HEADERS.slice(0, -1), "", BASE_TABLE_HEADERS.slice(-1)] : BASE_TABLE_HEADERS;
  const itemKeys = pendingReview ? [...BASE_ITEM_KEYS.slice(0, -1), "review", BASE_ITEM_KEYS.slice(-1)] : BASE_ITEM_KEYS;

  return (
    <div>
      <SelectableTable
        hideCheckboxes={true}
        tableHeaders={tableHeaders}
        filteredPaginatedItems={studentProfiles}
        itemComponents={{
          actions: <ActionIconsTableItem />,
          date_of_birth_with_age: <SimpleTableItem textPropKey="date_of_birth_with_age" />,
          full_name: (
            <SimpleTableItem
              subTextPropKey="student_info_sub_text"
              textPropKey="full_name"
              urlPropKey="edit_student_profile_url"
            />
          ),
          student_id: <SimpleTableItem textPropKey="student_id" />,
          school: <SimpleTableItem textPropKey="school" />,
          grade: <SimpleTableItem textPropKey="grade" />,
          required_immunizations_status: (
            <ComplianceStatusComponent
              immunizationStatusKey="required_immunizations_status"
              immunizationUrlKey="immunization_url"
            />
          ),
          review: <ReviewModalButton testGroup={testGroup} />,
        }}
        itemKeys={itemKeys}
      />
      <TablePagination
        containerClassName="mt-3"
        newTablesFlipperEnabled={true}
        {...metaProps}
      />
    </div>
  );
};

export default StudentProfilesTable;
